import { useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useLiterals } from '~/components/Literals'
import actions, { TYPES } from '../actions'
import api from '../api'

function IndexPage({ config, position, location }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const productsRedux = useSelector((state) => state.app.products, shallowEqual)
  const { getLiteral } = useLiterals()

  const getProducts = async (cnpj) => {
    dispatch(actions.products.start())
    try {
      const products = await api.getProducts(cnpj)
      dispatch(actions.products.success(products))
    } catch (error) {
      dispatch(
        actions.snack.add({
          id: Date.now(),
          message: getLiteral('1995')
        })
      )
      dispatch(actions.products.error())
    }
  }

  useEffect(() => {
    // reset
    dispatch(
      actions.updateApp({
        searchProductResults: null,
        currentProduct: null,
        stores: null,
        storesFetched: false,
        q: '',
        view: config.isOndetem
          ? TYPES.VIEW_HOME_PAGE
          : config.hideProductsList || config.all || config.partner || config.isDistributor
          ? TYPES.VIEW_EMPTY
          : config.showContextViewStore
          ? TYPES.VIEW_STORES
          : TYPES.VIEW_PRODUCTS
      })
    )

    document.title =
      config.brandName === 'Ondetem.App'
        ? getLiteral('2097')
        : `${getLiteral('2031')} ${config.brandName}`
  }, [location.key])

  useEffect(() => {
    if (!config.generic) {
      if (config.cnpj && !config.hideProductsList && !productsRedux && !config.isDistributor) {
        getProducts(config.cnpj)
      }
    }
  }, [config.cnpj, productsRedux])

  useEffect(() => {
    if ((!config.generic && !position.fetched) || (config.isOndetem && !position.fetched)) {
      // if (!config.isOndetem && location !== '/') position.fetchPosition()

      if (config.showContextViewStore) {
        history.replace('/produto/todos')
        return
      }

      if (config.gtin) {
        history.replace('/produto/' + (config.gtin === 'all' ? 'todos' : config.gtin))
      } else if (config.q) {
        history.replace('/busca?q=' + config.q)
      }
    }
  }, [position.fetched])

  return null
}

export default IndexPage
